import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, ObrasReducer, ObrasState } from "./obras-reducer";
import { PaginationResponse } from "models/pagination-response";
import { IObraPagedResponse } from "models/response/obra-paged-response";

const ObrasContext = createContext<ObrasState | undefined>(undefined);
const ObrasContextDispatchContext = createContext({} as any);

const ObrasProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(ObrasReducer, {
        obras: new PaginationResponse<IObraPagedResponse>([], 0, 1, 10, 0),
        obraPagedRequest: { page: 0, pageSize: 10 },
        situacoes: [],
        funcoes: [],
        tipos: [],
        ultimaAtualizacao: null,
        loading: false,
        error: null
    } as ObrasState);

    return (
        <ObrasContext.Provider value={state}>
            <ObrasContextDispatchContext.Provider value={dispatch}>
                {children}
            </ObrasContextDispatchContext.Provider>
        </ObrasContext.Provider>
    );
}

const useObrasState = () => {
    const context = useContext(ObrasContext);
    if (context === undefined) {
        throw new Error('useObrasState must be used within a ObrasProvider');
    }
    return context;
}

const useObrasDispatch = () => {
    const context = useContext(ObrasContextDispatchContext);
    if (context === undefined) {
        throw new Error('useObrasDispatch must be used within a ObrasProvider');
    }
    return context;
}

export { ObrasProvider, useObrasState, useObrasDispatch, ACTION_TYPES };
